import * as React from "react";
import { connect } from "react-redux";
import * as download from "downloadjs";
import {
  getFlightMarkersState,
  getSiteState,
  IStoreState,
} from "../../redux/rootReducer";
import { logCSVDownloaded } from "../../redux/modules/metrics/reducer";
import { IGcpAppDispatchProp } from "../../redux/store";
import Button from "../Generics/Button";
import { createPlacedOnlyCsv } from "../../redux/computables/csvFile/csvFile";
import { getEpsgFromSrs } from "../../utils/getEpsgFromSrs";
import { ISite } from "../../apiFacades/csu/site";

interface ICsvDownloadButtonProps extends IGcpAppDispatchProp {
  csvFileNew: string;
  isPilot: boolean;
  site: ISite;
}

const CsvDownloadButton = ({
  dispatch,
  csvFileNew,
  isPilot,
  site,
}: ICsvDownloadButtonProps) => {
  const srs = site.srs;
  const epsg = getEpsgFromSrs(srs);

  return (
    <Button
      stretched
      type="primary"
      label={`CSV ${isPilot ? `(EPSG:${epsg})` : ""}`}
      icon={<img src="icon-download.svg" />}
      onClick={() => {
        dispatch(logCSVDownloaded());
        download(csvFileNew, "Flight_Markers.csv", "text/csv");
      }}
    />
  );
};

export default connect(
  (
    store: IStoreState,
    { isPilot }: Pick<ICsvDownloadButtonProps, "isPilot">,
  ) => ({
    csvFileNew: createPlacedOnlyCsv(
      getFlightMarkersState(store),
      getSiteState(store),
      isPilot,
    ),
    site: getSiteState(store).data,
  }),
)(CsvDownloadButton);
